<template>
  <div class="operations">
    <Header :menu-at="0" headerTitle="Einsätze"/>
    <vue-headful title="Einsätze - FF Pfaffenhofen"/>

      
    <div class="container">
      <span class="large-icon">
        <font-awesome-icon icon="car-crash" />
      </span>

      <div class="header-container">
        <h1>Feuerwehr Pfaffenhofen im Einsatz</h1>
        <p>Hier finden Sie eine Übersicht über aktuelle Einsätze der Freiwillige Feuerwehr Pfaffenhofen.</p>
      </div>
      <div class="create-box" v-if="userID">
        <button class="btn-default" @click="createShow()">
          <font-awesome-icon icon="plus-circle" />
          Neuer Einsatz</button>
      </div>

    
    </div>
    <div class="content">
      <div class="container">
        <div class="flex-row" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <div class="operation"  v-for="(data, index) in operations" :key="data.id">
            <div class="show-year" v-if="data.createdShow">
              <p class="year">Einsätze im Jahr <span class="highlight">{{ data.createdYear }}</span> im Überblick:</p>
              <div class="divider"></div>
            </div>
            <div class="entry">
              <div class="control-buttons" >
                <button class="btn-control" @click="togglePost(index)" title="Mehr Anzeigen" v-if="!data.show"> 
                  <font-awesome-icon icon="plus" />
                </button>
                <button class="btn-control" @click="togglePost(index)" title="Weniger Anzeigen" v-else> 
                  <font-awesome-icon icon="minus" />
                </button>
                <button class="btn-control btn-upload" @click="appendShow(data.id, index)" title="Bild hochladen"  v-if="userID" v-show="data.show">
                  <font-awesome-icon icon="file-upload" />
                </button>
                <button class="btn-control" @click="editShow(data.id, index)" title="Bearbeiten"  v-if="userID" v-show="data.show">
                  <font-awesome-icon icon="cog" />
                </button>
                <button class="btn-control" @click="removeShow(data.id, index)" title="Löschen"  v-if="userID" v-show="data.show">
                  <font-awesome-icon icon="trash" />
                </button>
              </div>

              <div class="card-content">
                <p class="card-category" v-if="data.category" v-show="data.show">
                  <font-awesome-icon icon="tags" v-if="data.category"></font-awesome-icon>
                  {{ data.category }}
                </p>
                <h1 class="card-header"> {{ data.title }} </h1>
                <p class="card-data card-info" v-if="data.start">
                  <font-awesome-icon icon="clock" /> &nbsp;{{ data.start }}
                </p>
                <p class="card-place card-info" v-if="data.place">
                  <font-awesome-icon icon="map-marker" />
                    &nbsp; {{ data.place }}
                </p>
                <p class="card-text" v-html="data.description" v-if="data.show"></p>
                
                <div class="images" v-if="data.image_files && data.image_files.length > 0 && data.show">
                  <h2>Bilder</h2>
                  <div class="image-container" >
                    <div class="image" v-for="(image, imgIdx) in data.image_files" :key="image.id">
                      <img :src="image.thumb_url">
                      <div class="image-overlay">
                        <div class="btn-bar">
                          <button class="btn-option" @click="openGallerty(index, imgIdx)" title="Vergrößern">
                            <font-awesome-icon icon="expand" />
                            </button>
                          <button class="btn-option" @click="removeImage(image.file_id, index, imgIdx)" title="Bild löschen" v-if="userID">
                            <font-awesome-icon icon="trash" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <LightBox :images="data['lightbox_data']" :ref="'lightbox' + index" :show-caption="true" :show-light-box="false"></LightBox>
                </div>
              </div>
            </div>
          </div>

          <div class="operation" v-if="reachedEnd">
            <div class="entry">
              <div class="control-buttons" ></div>
              <div class="card-content">
                <h1 class="card-header">Ende</h1>
                <p class="card-text">Keine weiteren Einträge vorhanden.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
    <Footer />

    <modal name="create-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false" width="740px" :scrollable="true">
      <div class="create-modal modal">
        <h1>Neuer Einsatz <span class="number">({{createData.page }}/2)</span></h1>
        <p>Legen Sie neue Einträge über das folgende Formular an.</p>
        <form @submit.prevent="createSubmit()">
          <div class="page-1" v-if="createData.page == 1">
            <div class="flex-row">
              <div class="col-6">
                <label for="title">Titel <span class="required">*</span></label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="heading"/>
                  </span>
                  <input type="text" placeholder="Titel"  v-model="createData.title"/>
                </div>
                <p class="input-error" v-if="createData.errorTitle">Feld muss ausgefüllt werden.</p>
                <label for="title">Kategorie</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="tags"/>
                  </span>
                  <input type="text" placeholder="Kategorie"  v-model="createData.category"/>
                </div>
              </div>
              <div class="col-6">
                <label for="title">Startzeit</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="clock"/>
                  </span>
                  <input type="text" placeholder="Dienstag, 21.08.2018 - 21:50"  v-model="createData.start"/>
                </div>
                <label for="title">Endzeit</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="clock"/>
                  </span>
                  <input type="text" placeholder="Dienstag, 21.08.2018 - 22:20"  v-model="createData.end"/>
                </div>
              </div>
            </div>
            <label for="title">Inhalt <span class="required">*</span></label>
            <wysiwyg v-model="createData.body" placeholder="Text der Ankündigung" />
            <p class="input-error" v-if="createData.errorBody">Feld muss ausgefüllt werden.</p>
            <div class="footer">
              <button class="btn-primary" v-on:click.prevent="switchPage(2)">
                Weiter
                <font-awesome-icon icon="arrow-right" />
              </button>
              <button class="btn-default" @click="createHide()" type="reset">Abbrechen</button>
            </div>
          </div>
          <div class="page-2" v-if="createData.page == 2">
            <label for="title">Einsatzort</label>
            <div class="map">       
              <l-map style="height: 100%" :zoom="mapData.zoom" :center="mapData.center" @click="changeMarkerPosition($event)">
                <l-tile-layer :url="mapData.url" :attribution="mapData.attribution"></l-tile-layer>
                <l-marker :lat-lng="mapData.marker"></l-marker>
              </l-map>
            </div>
            <div class="input-row">
              <span class="input-icon">
                <font-awesome-icon icon="map-pin"/>
               </span>
                <input type="text" placeholder="Ort, Straße, ..."  v-model="createData.place"/>
            </div>
            <div class="footer">
              <button class="btn-primary" type="submit">
                <font-awesome-icon icon="plus-circle" />
                Erstellen
              </button>
              <button class="btn-default" v-on:click.prevent="switchPage(1)">
                <font-awesome-icon icon="arrow-left" />
                Zurück
              </button>
            </div>
          </div>
        </form>
      </div>
    </modal>

    <modal name="edit-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false" width="740px" :scrollable="true">
      <div class="edit-modal modal">
        <h1>Bearbeiten des Inhaltes <span class="number">({{editData.page }}/2)</span></h1>
        <p>Bearbeiten von Einsatz <b>{{ editData.origTitle }}</b>.</p>
        <form @submit.prevent="editSubmit()">
         <div class="page-1" v-if="editData.page == 1">
            <div class="flex-row">
              <div class="col-6">
                <label for="title">Titel <span class="required">*</span></label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="heading"/>
                  </span>
                  <input type="text" placeholder="Titel"  v-model="editData.title"/>
                </div>
                <p class="input-error" v-if="editData.errorTitle">Feld muss ausgefüllt werden.</p>
                <label for="title">Kategorie</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="tags"/>
                  </span>
                  <input type="text" placeholder="Kategorie"  v-model="editData.category"/>
                </div>
              </div>
              <div class="col-6">
                <label for="title">Startzeit</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="clock"/>
                  </span>
                  <input type="text" placeholder="Dienstag, 21.08.2018 - 21:50"  v-model="editData.start"/>
                </div>
                <label for="title">Endzeit</label>
                <div class="input-row">
                  <span class="input-icon">
                    <font-awesome-icon icon="clock"/>
                  </span>
                  <input type="text" placeholder="Dienstag, 21.08.2018 - 22:20"  v-model="editData.end"/>
                </div>
              </div>
            </div>
            <label for="title">Inhalt <span class="required">*</span></label>
            <wysiwyg v-model="editData.body" placeholder="Text der Ankündigung" />
            <p class="input-error" v-if="editData.errorBody">Feld muss ausgefüllt werden.</p>
            <div class="footer">
              <button class="btn-primary" v-on:click.prevent="switchPageEdit(2)">
                Weiter
                <font-awesome-icon icon="arrow-right" />
              </button>
              <button class="btn-default" @click="editHide()" type="reset">Abbrechen</button>
            </div>
          </div>
          <div class="page-2" v-if="editData.page == 2">
            <label for="title">Einsatzort</label>
            <div class="map">       
              <l-map style="height: 100%" :zoom="mapData.zoom" :center="editData.marker" @click="changeMarkerPositionEdit($event)">
                <l-tile-layer :url="mapData.url" :attribution="mapData.attribution"></l-tile-layer>
                <l-marker :lat-lng="editData.marker"></l-marker>
              </l-map>
            </div>
            <div class="input-row">
              <span class="input-icon">
                <font-awesome-icon icon="map-pin"/>
               </span>
                <input type="text" placeholder="Ort, Straße, ..."  v-model="editData.place"/>
            </div>
            <div class="footer">
              <button class="btn-primary" @click="editSubmit()" type="submit">
                <font-awesome-icon icon="cog"/>
                Bearbeiten
              </button>
              <button class="btn-default" v-on:click.prevent="switchPageEdit(1)">
                <font-awesome-icon icon="arrow-left" />
                Zurück
              </button>
            </div>
          </div>
        </form>
      </div>
    </modal>

    

    <modal name="delete-modal" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="delete-modal modal">
        <h1>Wirklich Löschen?</h1>
        <p>
          Sind Sie sicher das sie den Einsatz wirklich löschen wollen. <br>
          Gelöschte Einsätze kommen nicht wiederhergestellt werden.           
        </p>
        <div class="footer">
          <button class="btn-primary" @click="removeSubmit()">
            <font-awesome-icon icon="trash"/>
            Löschen</button>
          <button class="btn-default" @click="removeHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

    <modal name="append-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false">
      <div class="append-modal modal">
        <h1>Dateien hochladen</h1>
        <p>
          Fügen Sie Einträgen Bild-Dateien hinzu.          
        </p>
        <label for="files">Dateien</label>
        <vue-dropzone ref="vueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
        <div class="footer">
          <button class="btn-primary" @click="appendSubmit()">
            <font-awesome-icon icon="file-upload"/>
            Fertig</button>
          <button class="btn-default" @click="appendHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import LightBox from 'vue-image-lightbox'
import { EventBus } from '../event-bus.js'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';

export default {
  name: 'operations',
  components: {
    Header, LightBox, LMap, LTileLayer, LMarker, Footer,
    vueDropzone: vue2Dropzone
  },
  data: () => {
    return {
      userID: "",
      operations: [],
      selectedID: "",
      selectedIndex: "",
      busy: true,
      lastCreated: "",
      reachedEnd: false,
      mapData: {
        zoom: 16,
        center: [48.355722, 10.158270],
        url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: {"lat":48.357803901774254,"lng": 10.158233642578127},
      },
      createData: {
        page: 1,
        title: "",
        category: "",
        body: "",
        start: "",
        end: "",
        coords: "",
        place: "Pfaffenhofen a.d.Roth, Friedhofweg",
        errorTitle: false,
        errorBody: false
      },
      editData: {
        page: 1,
        id: "",
        title: "",
        origTitle: "",
        category: "",
        body: "",
        start: "",
        end: "",
        coords: "",
        place: "",
        errorTitle: false,
        errorBody: false
      },
      dropzoneOptions: {
        url: 'https://ff-pfaffenhofen.de/api/v1/operations/create/file',
        resizeWidth: 1024,
        acceptedFiles: '.jpg,.jpeg,.png',
        maxFilesize: 2,
        params: {
          opID: 1
        }
      }
    }
  },
  mounted() {
    this.userID = this.$session.get("userID")
    this.axios.get('https://ff-pfaffenhofen.de/api/v1/operations')
      .then( (res) => {
        this.operations = res["data"]["operations"]
        this.busy = false

        this.operations.forEach(element => {
          if(!element.coords) 
            return
          
          let latLng = element.coords.split(",")
          element.marker = {
            lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1])
          }
        });

        this.operations.forEach(element => {
          let createdYear = element.created.substring(0, 4)
          element.createdYear = createdYear
          
          let showYear = this.lastCreated != createdYear
          element.createdShow = showYear
          this.lastCreated = createdYear
        })

      })

    
    EventBus.$on('logout', () => {
      this.userID = ""
    })
    EventBus.$on('login', (userID) => {
      this.userID = userID
    })

  },
  methods: {
    changeMarkerPosition(e) {

      const key = "ig7USGq0PdpCQWR4ssmpvVZVeNXBJAdT"
      const location = e.latlng.lat + "," + e.latlng.lng
      this.createData.coords = location
      this.mapData.marker = e.latlng
      
      this.axios.get(
        'http://www.mapquestapi.com/geocoding/v1/reverse', {
          params: {
            key: key,
            location: location,
            outFormat: 'json'
        }
      }).then( (res) => {
        const location = res.data.results[0].locations[0]

        if(location.street) 
          this.createData.place = location.adminArea5 + ", " + location.street
        else 
          this.createData.place = location.adminArea5
      })

    },
    changeMarkerPositionEdit(e) {
      const key = "ig7USGq0PdpCQWR4ssmpvVZVeNXBJAdT"
      const location = e.latlng.lat + "," + e.latlng.lng
      this.editData.coords = location

      this.editData.marker = e.latlng
      
      this.axios.get(
        'http://www.mapquestapi.com/geocoding/v1/reverse', {
          params: {
            key: key,
            location: location,
            outFormat: 'json'
        }
      }).then( (res) => {
        const location = res.data.results[0].locations[0]

        if(location.street) 
          this.editData.place = location.adminArea5 + ", " + location.street
        else 
          this.editData.place = location.adminArea5
      })
    },
    switchPage(to) {

      if(to == 2) {
        this.createData.errorTitle = false
        this.createData.errorBody = false
        let error = false

        if(!this.createData.title) {
          this.createData.errorTitle = true
          error = true
        }

        if(!this.createData.body || this.createData.body == "<br>") {
          this.createData.errorBody = true
          error = true
        }

        if(error) return;
      }
      
      this.createData.page = to
    },
    switchPageEdit(to) {

      if(to == 2) {
        this.editData.errorTitle = false
        this.editData.errorBody = false
        let error = false

        if(!this.editData.title) {
          this.editData.errorTitle = true
          error = true
        }

        if(!this.editData.body || this.editData.body == "<br>") {
          this.editData.errorBody = true
          error = true
        }

        if(error) return;
      }
      
      this.editData.page = to
    },
    editShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index

      this.editData.id = id
      this.editData.title = this.operations[index].title
      this.editData.origTitle = this.operations[index].title
      this.editData.category = this.operations[index].category
      this.editData.body = this.operations[index].description
      this.editData.start = this.operations[index].start
      this.editData.end = this.operations[index].end
      this.editData.coords = this.operations[index].coords
      this.editData.place = this.operations[index].place

      if(this.editData.coords) {
        const latLng = this.operations[index].coords.split(',')

        this.editData.marker = {
          lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1])
        }

      }

      this.$modal.show('edit-modal')
    },
    editHide() {
        this.$modal.hide('edit-modal')
    },
    editSubmit() {
      this.editData.errorTitle = false
      this.editData.errorBody = false
      let error = false

      if(!this.editData.title) {
        this.editData.errorTitle = true
        error = true
      }

      if(!this.editData.body || this.editData.body == "<br>") {
        this.editData.errorBody = true
        error = true
      }

      if(error) return;

      let data = {
        opID: this.selectedID,
        title: this.editData.title,
        body: this.editData.body,
        category: this.editData.category,
        userID: this.userID,
        place: this.editData.place,
        coords: this.editData.coords,
        start: this.editData.start,
        end: this.editData.end
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/edit', 
        data , {withCredentials: true})
      .then(() => {
        this.$modal.hide('edit-modal')
        this.editData.page = 1
        this.operations[this.selectedIndex].title = this.editData.title
        this.operations[this.selectedIndex].category = this.editData.category
        this.operations[this.selectedIndex].description = this.editData.body
        this.operations[this.selectedIndex].start = this.editData.start
        this.operations[this.selectedIndex].end = this.editData.end
        this.operations[this.selectedIndex].place = this.editData.place
        this.operations[this.selectedIndex].coords = this.editData.coords

      })

    },
    removeShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.$modal.show('delete-modal')
    },
    removeHide() {
      this.$modal.hide('delete-modal')
    },
    removeSubmit() {

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/delete', {
        opID: this.selectedID
      }, {withCredentials: true})
      .then(() => {
        this.$modal.hide('delete-modal')
        this.operations.splice(this.selectedIndex, 1)
      })

    },
    createShow() {
      this.$modal.show('create-modal')
    },
    createHide() {
      this.$modal.hide('create-modal')
      this.createData.title = ""
      this.createData.category = ""
      this.createData.body = ""
    },
    createSubmit() {
      this.createData.errorTitle = false
      this.createData.errorBody = false
      let error = false

      if(!this.createData.title) {
        this.createData.errorTitle = true
        error = true
      }

      if(!this.createData.body || this.createData.body == "<br>") {
        this.createData.errorBody = true
        error = true
      }

      if(error) return;

      let data = {
        title: this.createData.title,
        body: this.createData.body,
        category: this.createData.category,
        userID: this.userID,
        place: this.createData.place,
        coords: this.createData.coords,
        start: this.createData.start,
        end: this.createData.end
      }

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/create', 
        data , {withCredentials: true})
      .then((response) => {
        this.operations.unshift(response.data)
        this.$modal.hide('create-modal')
      })

    },
    loadMore() {
      this.busy = true
      this.axios.get(
        'https://ff-pfaffenhofen.de/api/v1/operations', {
          params: {
            offset: this.operations.length
          }
        })
      .then( (res) => {
        let data = res.data["operations"]
        data.forEach(item => {
          
          let createdYear = item.created.substring(0, 4)
          item.createdYear = createdYear

          let showYear = this.lastCreated != createdYear
          item.createdShow = showYear

          this.lastCreated = createdYear

          this.operations.push(item)
        });


        if(data.length != 0) {
          this.busy = false
        } else {
          this.reachedEnd = true
        }
      })

    },
    appendShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.dropzoneOptions.params.opID = id
      this.$modal.show('append-modal')
    },
    appendHide() {
      this.$modal.hide('append-modal')
    },
    appendSubmit() {
      this.$modal.hide('append-modal')

      // XXX make dynamic
      this.userID = this.$session.get("userID")
      this.axios.get('https://ff-pfaffenhofen.de/api/v1/operations')
        .then( (res) => {
          this.operations = res["data"]["operations"]
          this.busy = false
        })

    },
    removeAttachment(id, idx, attIdx) {
      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/delete/file', {
          "opID": id
        }, {withCredentials: true})
      .then(() => {
        let docFiles = this.operations[idx]["document_files"]
        docFiles.splice(attIdx, 1)
      })
    },
    removeImage(id, idx, attIdx) {
      this.axios.post('https://ff-pfaffenhofen.de/api/v1/operations/delete/file', {
          "opID": id
        }, {withCredentials: true})
      .then(() => {
        let imgFiles = this.operations[idx]["image_files"]
        imgFiles.splice(attIdx, 1)
      })
    },
    openGallerty(idx, imgIdx) {
      const lightbox = this.$refs['lightbox' + idx]
      lightbox[0].showImage(imgIdx)
    },
    togglePost(index) {
      let toggleState = this.operations[index].show
      this.operations[index].show = !toggleState
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/theme.scss";
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
@import "~leaflet/dist/leaflet.css";



.header-container {
  margin-left: 115px;
}

.container {
  position: relative;
}

.large-icon {
  position: absolute;
  left: 20px;
  top: 20px;
  font-size: 70px;
  color: $primary-1;
}

.operations {
  padding-top: 60px;
}

.post {
  margin-bottom: 60px;
}

.content {
  padding-top: 30px;
  min-height: 600px;
}

.images {
  h2 {
    font-size: 18px;
  }
}

.create-box {
  display: flex;
  justify-content: center;
  margin: 10px 0px 0px 0px;
  padding: 20px 0px 0px 0px;

  .btn-default {
    width: 100%;
    background: $light-0;
    padding: 20px;
    font-size: 18px;
    font-weight: bold;
    border: 2px dashed #b3b3b3;

    transition: 200ms;
    &:hover {
      border: 2px dashed $primary;
      color: $primary;
      transition: 200ms;
    }

    svg {
      color: $primary;
      margin-right: 10px;
    }
  }
}


.entry {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px 20px;
  display: flex;

  background: $light-0;
  box-shadow: $shadow-light;
  border: 1px solid lighten($gray-0, 15%);
  border-radius: 6px;

}

.control-buttons {
  width: 40px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-right: 20px;
  padding-top: 20px;

  @include tablet {
    width: 80px;
  }
}

.btn-control {
  margin: 5px auto;
  width: 40px;
  height: 40px;
  background: $light-0;
  border: 1px solid #b3b3b3;
  text-align: center;
  border-radius: 100%;
  cursor: pointer;

  &:hover {
    color: $primary;
    border: 1px solid $primary;
  }
}

.btn-upload {
  margin-bottom: 40px;
}

.card-category {
  color: $primary;
  text-transform: uppercase;
  margin-bottom: -5px;
}

.card-header {
  color: $dark;
  font-size: 18px;
  margin-bottom: 15px;

  @include tablet {
    font-size: 26px;
  }
}

.card-info {
  opacity: 0.8;
  color: #5c5a5a;
  margin-top: -12px;
}

.card-content {
  flex-grow: 1;
}

#dropzone {
  overflow: auto;
  white-space: nowrap;
}

.modal {
  padding: 10px 30px;

  h1 {
    color: $primary;

    .number {
      font-size: 22px;
      opacity: 0.7;
    }
  }

  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    flex-wrap: wrap;

    .col-6 {
      width: 100%;

      @include tablet {
        width: 48%;
        margin: 0px 1%;
      }
    }
  }

  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }
    .btn-default {
      color: lighten($dark, 40);

      &:hover {
        color: $dark;
      }
    }
    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }

  label {
    color: $dark;
    font-weight: bolder;

    .required {
      color: $primary;
    }
  }

  .input-row {
    margin: 4px 0px 12px 0px;
    display: flex;
  }

  .input-icon {
    background: lighten($gray, 48);
    color: lighten($dark, 12);
    
    border: 1px solid #e4e4e4;
    border-right: none;
    padding: 8px 14px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  input {
    flex-grow: 1;
    border: 0px;
    padding: 0px 12px;
    border: 1px solid #e4e4e4;
    font-size: 16px;

    &:focus, &:active {
      box-shadow: 0px 0px 4px $primary;
    }
  }

  .input-error {
    color: $primary;
    margin-top: -6px;
  }

  .map {
    height: 350px;
    width: 100%;
  }
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .image {
    width: 45%;
    margin: 1% 2.5%;
    position: relative;

    @include tablet {
      width: 30%;
      margin: 1% 1%;
    }

    @include max {
      width: 22%;
      margin: 1% 1%;
    }
  }

  .image-overlay {
    position: absolute;
    width: 100%;
    height: calc(100% - 5px);
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    opacity: 0;

    &:hover {
      opacity: 1;
    }

    .btn-bar {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      button {
        background: none;
        border: none;
        color: $light-0;
        font-size: 32px;
        width: 80px;
        cursor: pointer;

        &:hover {
          color: lighten($primary, 20%);
        }
      }
    }
  }

  img {
    width: 100%;
  }
}

.show-year {
  .year {
    color: $dark;
    font-size: 22px;
    font-weight: 800;

    .highlight {
      color: $primary-0;
    }
  }

  .divider {
    height: 2px;
    width: 100%;
    background: $dark;
    margin: -15px 0px 10px 0px;
    opacity: 0.5;

    @include desktop {
      width: 400px;
    }
  }
}

</style>



